import { useMemo } from 'react';
import { LEGACY_CONTENT_MODEL_SAVED_VIEW_PROPERTY_NAMES_TO_CMP_PROPERTY_NAMES } from '../constants/properties';
import useContentPlatformListingConfiguration from './useContentPlatformListingConfiguration';
import useTableColumnUserSettingsKeys from './useTableColumnUserSettingsKeys';
import { useCmsUserSettings } from './useCmsUserSettings';
const useTableColumns = () => {
  const {
    hasViews,
    defaultTableColumns
  } = useContentPlatformListingConfiguration();
  const {
    columnUserSettingsKey,
    legacyColumnKey
  } = useTableColumnUserSettingsKeys();
  const {
    userSettings
  } = useCmsUserSettings({
    skip: hasViews
  });
  return useMemo(() => {
    /**
     * If `legacyColumnKey` exists we will always read
     * from that key and map the columns to the new key.
     */
    const legacyColumns = legacyColumnKey && legacyColumnKey in userSettings ? userSettings[legacyColumnKey].map(column => {
      return LEGACY_CONTENT_MODEL_SAVED_VIEW_PROPERTY_NAMES_TO_CMP_PROPERTY_NAMES[column] || column;
    }) : undefined;
    return legacyColumns || userSettings[columnUserSettingsKey] || defaultTableColumns;
  }, [userSettings, columnUserSettingsKey, defaultTableColumns, legacyColumnKey]);
};
export default useTableColumns;